<template lang="html">
  <div :class="[$style.flex, $style.controls]">
    <div :class="[$style.flex, $style.navigation]">
      <IxButton
        v-if="$listeners['back-to-workspace']"
        large back
        @click="$emit('back-to-workspace')"
      >
        <IxRes>powerBi.buttons.backToWorkspace</IxRes>
      </IxButton>

      <IxButton
        v-if="$listeners['back-to-dashboard']"
        large :icon="icons.backToDashboard"
        @click="$emit('back-to-dashboard')"
      >
        <IxRes>Common.SR_Common.BackToDashboard</IxRes>
      </IxButton>
    </div>

    <div :class="[$style.flex, $style.title]">
      <h3>{{ name }}</h3>
    </div>

    <div :class="[$style.flex, $style.functions]">
      <IxButton
        v-if="$listeners.print"
        large :icon="icons.print"
        @click="$emit('print')"
      >
        <IxRes>Common.SR_Common.Print</IxRes>
      </IxButton>

      <IxButton
        v-if="$listeners.fullscreen"
        large :icon="icons.fullscreen"
        @click="$emit('fullscreen')"
      >
        <IxRes>Common.SR_Common.Fullscreen</IxRes>
      </IxButton>
    </div>
  </div>
</template>

<script>
import IxButton from '@components/IxButton'
import {faChartLine, faExpand, faPrint} from '@fortawesome/free-solid-svg-icons'

export default {
  components: {
    IxButton
  },
  props: {
    name: String
  },
  computed: {
    icons () {
      return {
        print: faPrint,
        fullscreen: faExpand,
        backToDashboard: faChartLine
      }
    }
  }
}
</script>

<style lang="scss" module>
.flex {
  display: flex;
  align-items: center;
}

.controls {
  justify-content: space-between;

  border-bottom: 1px solid gray;
  padding: 0.25em;

  > * {
    flex: 1;
  }
}

.navigation {
  justify-content: flex-start;
}

.title {
  justify-content: center;

  > h3 {
    margin: 0;
  }
}

.functions {
  justify-content: flex-end;
}

.navigation, .functions {
  > :not(:first-child) {
    margin-left: 0.5em;
  }
}
</style>
